<template lang="pug">
.modelAudit
  modelLoad(ref='modelLoad')
</template>

<script>
/**
 * 警告 ！！
 * 请不要格式化文档，本来可读性很强了，不要很简单的组件整好几十行 ！！！
 * 对应组件的功能写到对应组件上，不明白别乱写，搞得看不懂我找你 ！！！
 */
import modelLoad from "./component/modelLoad.vue";
export default {
  components: { modelLoad }
};
</script>
<style lang="scss" scoped>
.modelAudit{
  width: 100%;
  height: 100%;
  min-width: 800px;
  min-height: 300px;
  position: relative;
  overflow: hidden;
}
</style>
